import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, InputNumber, Modal, Popover, Table, Image, Spin, message, Progress } from 'antd'
import type { TableProps } from 'antd'
import { QuestionCircleOutlined, FileDoneOutlined, CheckCircleOutlined, WarningOutlined } from '@ant-design/icons'
import { downloadFile } from '@/utils/utils'
import { utils, read } from 'xlsx'
import { useIntl } from 'react-intl'
import styles from './index.module.scss'
import listApi from "@/api/listApi";
import orderApi from "@/api/orderApi";
import MainContext from "@/stores/stores";
import ImgList from "@/pages/Cart/ImgList";
import PreviewImg from "../PreviewImg";
import { hex_md5 } from '@/utils/md5'
import { useNavigate } from 'react-router-dom'


let fileKey: number = 1

const ExportinOe: React.FC<any> = (props) => {
  const { btnStyle = {}, qStyle = {} } = props
  const intl = useIntl()
  const navigate = useNavigate()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { isCst } = commonStore
  const [open, setOpen] = useState<boolean>(false)
  const [errorOpen, setErrorOpen] = useState<boolean>(false)

  const [tab, setTab] = useState<'success' | 'error'>("success")
  const [rowKeys, setRowKeys] = useState<any>([])

  const [errorList, setErrorList] = useState<string[]>([])
  const [list, setList] = useState<any[]>([])
  const [importRows, setImportRows] = useState<any[]>([])

  const [loading, setLoading] = useState<boolean>(false)
  const [cartLoading, setCartLoading] = useState<boolean>(false)
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [exportLoading, setExportLoading] = useState<boolean>(false)
  const [exportProgress, setExportProgress] = useState<number>(0)

  const [previewImgShow, setPreviewImgShow] = useState<boolean>(false)
  const [previewSrc, setPreviewSrc] = useState<string>('')
  const [previewSrcList, setPreviewSrcList] = useState<string[]>([])

  const [change, setChange] = useState<boolean>(false)

  const isXts: boolean = window.location.host.includes("xts.") || window.location.host.includes("webtest.") || window.location.host.includes("localhost:300")

  const columns: TableProps<any>['columns'] = [
    {
      title: intl.formatMessage({ id: '品牌' }),
      dataIndex: 'brand_names',
      align: 'center',
      width: 120,
    },
    {
      title: intl.formatMessage({ id: '商品信息' }),
      dataIndex: 'id',
      render: (text: any, record: any) => {
        return (
          <div className="flex">
            <ImgList 
              srcList1={record.images ? record.images : ''} 
              srcList2={record.oe_image_info && record.oe_image_info.imagePath ? record.oe_image_info.imagePath : ''}
              onPreview={onPreviewImg}
              size="small"
            />
            <div className="ml5">
              <h3>{record.part_name}</h3>
              <div>编码：{record.code}</div>
              <div>OE号：{ record.quality_oe || record.oe || '' }</div>
            </div>
          </div>
        )
      }
    },
    {
      title: intl.formatMessage({ id: '数量' }),
      dataIndex: 'inputnum',
      align: 'center',
      render: (text: any, record: any) => {
        return (
          <div className="flex-c-c">
            {
              record.quality_price ? (
                <i className="iconfont icon-shanchu pointer" style={{ color: '#d9d9d9', fontSize: 22 }} onClick={() => numChange(record, text - 1)} />
              ): null
            }
            <InputNumber
              className="mlr10"
              value={text || 1}
              onChange={(value) => numChange(record, value)}
              disabled={!record.quality_price}
            />
            {
              record.quality_price ? (
                <i className="iconfont icon-Union4 pointer" style={{ color: '#d9d9d9', fontSize: 22 }} onClick={() => numChange(record, text + 1)} />
              ): null
            }
          </div>
        )
      }
    },
    {
      title: intl.formatMessage({ id: '单价' }),
      dataIndex: 'quality_price',
      align: 'center',
      width: 120,
      render: (text: any) => {
        if(!text) return null
        return (
          <text>{priceUnit}{text}</text>
        )
      }
    },
    {
      title: intl.formatMessage({ id: '总价' }),
      dataIndex: 'quality_price',
      align: 'center',
      width: 120,
      render: (text: any, record: any) => {
        if(!text) return null
        return (
          <text>{priceUnit}{text * (record.inputnum || 1)}</text>
        )
      }
    },
  ]

  useEffect(() => {
    if(!open) {
      setErrorList([])
      setList([])
      setImportRows([])
      setTab("success")
      setRowKeys([])
    }
  },[open])

  const numChange = (item: any, value: any) => {
    item['inputnum'] = value || 1
    setChange(c => !c)
  }

  const exportinOe = (event: any) => {
    console.log(event)
    const file = event.target.files[0];
    const name = file.name || ''

    const reader = new FileReader()
    if(name.includes("xlsx")) {
      setLoading(true)
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result)
        const workbook = read(data, { type: 'array', cellFormula: false, cellHTML: false,  })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 })
        console.log(jsonData)
        let oeObj: any = {}
        let importRowsData: any[] = []
        let keyword: any = ''
        let goods_id: any = ''
        let oe_search_info: any = []
        jsonData.forEach((it: any, index: number) => {
          let valueArr: any = Object.values(it)
          let importValue = valueArr[0] === undefined || valueArr[0] === null ? '' : `${valueArr[0]}`.trim()
          if(importValue && !/[\u4e00-\u9fa5]/.test(importValue)) {
            let inputnum = valueArr[1] ? parseInt(`${valueArr[1]}`) : 1
            inputnum = Number.isNaN(inputnum) ? 1 : inputnum
            keyword += `${keyword ? ',' : ''}${importValue}`
            oeObj[importValue] = inputnum
            importRowsData.push({
              value: importValue,
              inputnum,
              index,
              type: importValue.includes('.') ? 'oe' : 'code'
            })
          }
        })
        setImportRows(importRowsData)
        listApi.searchPartKeyword({keyword}).then((res: any) => {
          
          if(res.code === 1) {
            
            res.data?.list.forEach((item: any) => {
              goods_id += `${goods_id ? ',' : ''}${item.goods_id}`
            })
            oe_search_info = res.data?.list || []
            setErrorList(res.data?.no_find_oe.filter((it: any) => !it.includes(",")))
            let params = {
              page: 1,
              size: 600,
              goods_id,
              oe_search_info,
              stype: 'oe',
              is_cst: isCst,
              "part_name": "",
              "brand": "",
              "label_name": "",
              "position": "",
              "brand_names": "",
              "no_find_oe": keyword,
            }
            if(!goods_id) {
              setLoading(false)
              return false
            }
            listApi.getNewPartList(params).then((result: any) => {
              if(res.code === 1) {
                let list = result.data.list
                let codeList = list.map((item: any) => {
                  return {
                    code: item.code,
                    brand_names: item.brand_names
                  }
                })
                if(codeList.length) {
                  listApi.getNewPartListPrice({
                    goods_codes: codeList,
                    warranty: 1,
                    shop_search: 1
                  }).then((lastResult: any) => {
                    setLoading(false)
                    if(lastResult.code === 1) {
                      let codeData: any = lastResult.data
                      let _list: any[] = []
                      list.forEach((item: any) => {
                        let goods_id = item.goods_id
                        let index = oe_search_info.findIndex((ele: any) => goods_id && ele.goods_id === goods_id)
                        let search_oe = index > -1 ? oe_search_info[index].keyword : ''
                        _list.push({
                          type: 2,
                          ...item,
                          quality_oe: item.oe,
                          from_oe: item.oe,
                          search_oe: search_oe,
                          ...codeData[item.code],
                          inputnum: oeObj[item.code] ? oeObj[item.code] : (oeObj[search_oe] ? oeObj[search_oe] : 1)
                        })
                        if(!codeData[item.code].quality_price) {
                          
                        }
                      })
                      // _list = _list.filter((it) => it.quality_price)
                      setRowKeys(_list.filter((it) => it.code && it.quality_price).map((it) => it.code))
                      setList(_list)
                    }
                  })
                }else {
                  setLoading(false)
                }
              }else {
                setLoading(false)
              }
            })
          }else {
            setLoading(false)
          }
        })
        setOpen(true)
        
      }
      reader.readAsArrayBuffer(file);
    }
    fileKey = fileKey + 1
  }

  const onPreviewImg = (src: string, imgList: string[]) => {
    setPreviewSrc(src)
    setPreviewSrcList(imgList)
    setPreviewImgShow(true)
  }
  const closePreviewImg = () => {
    setPreviewImgShow(false)
    setPreviewSrc('')
    setPreviewSrcList([])
  }

  const copytext = () => {
    // 自动拼接换行符
    const copyText = errorList.join("\n");

    // 执行复制
    navigator.clipboard.writeText(copyText).then(() => {
      message.success(intl.formatMessage({ id: "复制成功！" }));
    }).catch(err => {
      console.log("复制失败", err);
    });
    return false
  }

  const getCartData = () => {
    return new Promise((reslove) => {
      orderApi.getCartList().then((res: any) => {
        if(res.code === 1) {
          let goods_code_list: any = []
          let _data = res.data
          let price = 0
          Object.keys(_data).forEach((items: string) => {
            Object.keys(_data[items].goods_list).forEach((item: string) => {
              _data[items].goods_list[item].selected = true
              if(_data[items].goods_list[item].stock_type === 'epc'){
                const d = _data[items].goods_list[item].data
                const basic = d.basic
                const supportBuy = d.supportBuy
                if(basic && supportBuy){
                  if(basic.pic && basic.pic.length){
                    _data[items].goods_list[item].images = basic.pic[0].pic
                  }else {
                    _data[items].goods_list[item].images = d.detail.img || ''
                  }
                  _data[items].goods_list[item].part_name = basic.label
                  _data[items].goods_list[item].quality_name = intl.formatMessage({id: '大库原厂'})
                  _data[items].goods_list[item].quality_oe = supportBuy.pid
                  if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                    _data[items].goods_list[item]['4s_price'] = supportBuy.DMS.price / 100
                  }
                  _data[items].goods_list[item].quality_price = supportBuy.DMS.purchase_price / 100
                  if(supportBuy.DMS.purchase_price) {
                    price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                  }
                }
              }else if(_data[items].goods_list[item].stock_type === 'yc'){
                const info = _data[items].goods_list[item].data
                _data[items].goods_list[item].images = info.img || info.detail.img || ''
                _data[items].goods_list[item].part_name = info.part_name
                _data[items].goods_list[item].quality_name = intl.formatMessage({id: '原厂'})
                _data[items].goods_list[item].quality_oe = info.oe
                if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                  _data[items].goods_list[item]['4s_price'] = info.price_4s
                }
              }else {
                goods_code_list.push({
                  code: item,
                  goods_cst_id: _data[items].goods_list[item].goods_cst_id,
                  brandCode: _data[items].goods_list[item].data ? _data[items].goods_list[item].data.brandcode : ''
                })
              }
              
            })
          })
          reslove(_data)
        }
      })
    })
    
  }

  const refreshCartNum = () => {
    orderApi.getCartList().then((res: any) => {
      if(res.code === 1) {
        let length = 0
        let _data = res.data || {}
        Object.keys(_data).forEach((items: string) => {
          Object.keys(_data[items].goods_list || {}).forEach(() => {
            length += 1
          })
        })
        setCommonStore({
          type: 'cartNum',
          value: length
        })
      }
    })
  }

  const getSelectData = (data?: any) => {
    let cartData: any = {}
    if(data) {
      cartData = data
    }
    let _list = list.filter((it) => rowKeys.includes(it.code)) 
    _list.forEach((items: any) => {
      let _brandCode = items.oe_image_info && items.oe_image_info.brandCode ? items.oe_image_info.brandCode : (items.brandCode ? items.brandCode : '')
      if(isCst) {
        let hash_msg = 'oe&' + items.code
        let hash_value = hex_md5(hash_msg)
        let param: any = {
          query_type: 'oe',
          query_info: {
            code: items.code,
            goods_id: items.goods_id,
            brandcode: _brandCode
          },
          goods_list: {
            [items.code]: {
              goods_code: items.code,
              num: items.inputnum || 1,
              goods_cst_id: items.goods_cst_id,
              stock_type: 'erp',
              fromDtl: 'goods', // part 产品详情  goods商品详情  pid零件号详情
              data: {
                code: items.code,
                goods_id: items.goods_id, 
                brandcode: _brandCode
              },
            },
          }
        }
        if(cartData[hash_value]) {
          cartData[hash_value].goods_list[items.code].num += items.inputnum || 1
        }else {
          cartData[hash_value] = param
        }
      }else {
        let pid = items.from_oe.replace(/\s+/g, '')
        let hash_value = hex_md5('goods' + pid)
        if(pid) {
          let param: any = {
            query_type: 'oe',
            query_info: {
              code: items.code,
              oe: pid,
              vin_img: "",
              brandcode: _brandCode,
            },
            goods_list: {
              [items.code]: {
                goods_code: items.code,
                num: items.inputnum || 1,
                goods_cst_id: items.goods_cst_id ? items.goods_cst_id : '',
                stock_type: 'erp',
                fromDtl: 'pid', // part 产品详情  goods商品详情  pid零件号详情
                goods_id: items.goods_id,
                data: {
                  title: pid,
                  detail: {},
                  code: items.code,
                  oe: pid,
                  brandcode: _brandCode
                }
              },
            }
          }
          if(cartData[hash_value]) {
            if(cartData[hash_value].goods_list[items.code]) {
              cartData[hash_value].goods_list[items.code].num += items.inputnum || 1
            }else {
              cartData[hash_value].goods_list[items.code] = param.goods_list[items.code]
            }
          }else {
            cartData[hash_value] = param
          }
        }
      }
    })
    return cartData
  }
  const addSelectCart = async () => {
    let cartData: any = await getCartData()
    let data = getSelectData(cartData)

    setCartLoading(true)
    orderApi.updateCart({data: data}).then((res: any) => {
      setCartLoading(false)
      if(res.code === 1) {
        message.success("操作成功！")
        refreshCartNum()
        navigate('/cart')
        setOpen(false)
      }
    })
  }

  const toBuy = () => {
    if(!localStorage.getItem('token') || localStorage.getItem('tourist_user')) {
      setOpen(false)
      navigate('/login')
      return false
    }
    let _data = getSelectData({})

    // console.log(_data)
    // return false
    let cartData: any = {}
    let goods_code_list: any = []
    let price = 0
    setSubmitLoading(true)
    Object.keys(_data).forEach((items: string) => {
      Object.keys(_data[items].goods_list).forEach((item: string) => {
        _data[items].goods_list[item].selected = true
        if(_data[items].goods_list[item].stock_type === 'epc'){
          const d = _data[items].goods_list[item].data
          const basic = d.basic
          const supportBuy = d.supportBuy
          if(basic && supportBuy){
            if(basic.pic && basic.pic.length){
              _data[items].goods_list[item].images = basic.pic[0].pic
            }else {
              _data[items].goods_list[item].images = d.detail.img || ''
            }
            _data[items].goods_list[item].part_name = basic.label
            _data[items].goods_list[item].quality_name = intl.formatMessage({id: '大库原厂'})
            _data[items].goods_list[item].quality_oe = supportBuy.pid
            if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
              _data[items].goods_list[item]['4s_price'] = supportBuy.DMS.price / 100
            }
            _data[items].goods_list[item].quality_price = supportBuy.DMS.purchase_price / 100
            if(supportBuy.DMS.purchase_price) {
              price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
            }
          }
        }else if(_data[items].goods_list[item].stock_type === 'yc'){
          const info = _data[items].goods_list[item].data
          _data[items].goods_list[item].images = info.img || info.detail.img || ''
          _data[items].goods_list[item].part_name = info.part_name
          _data[items].goods_list[item].quality_name = intl.formatMessage({id: '原厂'})
          _data[items].goods_list[item].quality_oe = info.oe
          if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
            _data[items].goods_list[item]['4s_price'] = info.price_4s
          }
        }else {
          goods_code_list.push({
            code: item,
            goods_cst_id: _data[items].goods_list[item].goods_cst_id,
            brandCode: _data[items].goods_list[item].data ? _data[items].goods_list[item].data.brandcode : ''
          })
        }
        
      })
    })
    if(goods_code_list.length > 0) {
      listApi.getAllGoods({
        goods_codes: goods_code_list
      }).then((res1: any) => {
        setSubmitLoading(false)
        if(res1.code === 1) {
          let _data1 = res1.data
          Object.keys(_data).forEach((items: string) => {
            Object.keys(_data[items].goods_list).forEach((item: string) => {
              if(_data[items].goods_list[item].stock_type !== 'epc' && _data[items].goods_list[item].stock_type !== 'yc'){
                try{
                  _data[items].goods_list[item] = {
                    ..._data[items].goods_list[item],
                    ..._data1[_data[items].goods_list[item].goods_cst_id][item]
                  }
                  if(_data[items].goods_list[item].quality_price) {
                    price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                  }
                }catch(err) {
                  console.info(err)
                }
              }
            })
          })

          cartData = _data
          let _cartData: any = {}
          let isQualityPrice = false
          Object.keys(cartData).forEach((items: string) => {
            let goods_list: any = {}
            let goods_list_num: number = 0
            Object.keys(cartData[items].goods_list).forEach((item: any) => {
              if(cartData[items].goods_list[item].selected) {
                goods_list_num++
                goods_list[item] = cartData[items].goods_list[item]
                if(!cartData[items].goods_list[item].quality_price) {
                  isQualityPrice = true
                }
              }
            })
            if(goods_list_num > 0) {
              _cartData[items] = {
                ...cartData[items],
                goods_list: goods_list
              }
            }
          })
          console.log(_cartData)
          // return false
          setOpen(false)
          let buyDataStr = JSON.stringify(_cartData)
          sessionStorage.setItem('buyData', buyDataStr)
          navigate(`/confirmOrder?buy_type=goods&from=goods`)

          // setCartData(_data)
        }
        
      }).catch((err: any) => {
        
      })
      
    }else {
      // setLoading(false)
      // cartData = _data
      // setCartData(_data)
      // setCommonStore({
      //   type: 'cartPrice',
      //   value: parseFloat(price.toFixed(2))
      // })
    }



    // console.log(data)
    // let buyDataStr = JSON.stringify(_cartData)
    // sessionStorage.setItem('buyData', buyDataStr)
    // navigate(`/confirmOrder?buy_type=cart&from=goods`)
    // console.log(data)
  }

  const priceUnit = useMemo(() => {
    let _unit: string = ''
    if(commonStore.currency_data) {
      if(commonStore.currency_data.unit) {
        _unit = commonStore.currency_data.unit
      }else if(commonStore.currency_data.code) {
        _unit = commonStore.currency_data.code + ' '
      }
    }
    return _unit ? _unit : ''
  }, [commonStore.currency_data])

  const totalNum = useMemo(() => {
    let tnum = 0
    list.forEach((it) => {
      if(rowKeys.includes(it.code)) {
        tnum += it.inputnum
      }
    })
    return tnum
  },[list, rowKeys, change])

  const totalMoneny = useMemo(() => {
    let tmoneny = 0
    list.forEach((it) => {
      if(rowKeys.includes(it.code)) {
        if(it.quality_price) {
          tmoneny += it.quality_price * it.inputnum
        }
      }
    })
    return `${priceUnit}${tmoneny}`
  },[list, rowKeys, change, priceUnit])

  const generateExcel = async () => {
    const normalizeValue = (value: any) => {
      return value === undefined || value === null ? '' : `${value}`.trim()
    }
    const usedIndexMap: any = {}
    const selectedList = importRows.length ? importRows.reduce((arr: any[], row: any) => {
      const rowValue = normalizeValue(row.value)
      const matchedList: any[] = []
      list.forEach((item: any, index: number) => {
        const searchOe = normalizeValue(item.search_oe)
        const code = normalizeValue(item.code)
        const qualityOe = normalizeValue(item.quality_oe || item.oe)
        if(searchOe === rowValue || code === rowValue || qualityOe === rowValue) {
          matchedList.push(item)
          usedIndexMap[index] = true
        }
      })
      if(matchedList.length) {
        return arr.concat(matchedList)
      }
      return arr.concat({
        code: row.type === 'code' ? row.value : '',
        quality_oe: row.type === 'oe' ? row.value : '',
        inputnum: row.inputnum || 1,
        is_unmatched: true,
      })
    }, []).concat(list.filter((item: any, index: number) => !usedIndexMap[index])) : list
    if(!selectedList.length) {
      message.warning(intl.formatMessage({ id: '请先选择要导出的数据' }))
      return
    }
    setExportLoading(true)
    let _window: any = window
    try {
      const workbook = new _window.ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('OE匹配结果')

      const columns = [
        { header: intl.formatMessage({ id: '图片' }), key: 'img', width: 10 },
        { header: intl.formatMessage({ id: '品牌' }), key: 'brand_names', width: 15 },
        { header: intl.formatMessage({ id: '产品名称' }), key: 'part_name', width: 20 },
        { header: intl.formatMessage({ id: '产品编码' }), key: 'code', width: 15 },
        { header: intl.formatMessage({ id: '原厂OE' }), key: 'quality_oe', width: 20 },
        { header: intl.formatMessage({ id: '数量' }), key: 'inputnum', width: 10 },
        { header: intl.formatMessage({ id: '单价' }), key: 'quality_price', width: 10 },
        { header: intl.formatMessage({ id: '总价' }), key: 'total_price', width: 10 },
      ]

      worksheet.columns = columns

      worksheet.getRow(1).font = { bold: true }
      worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCC' }
      }

      const imgIndex = 0

      for (let i = 0; i < selectedList.length; i++) {
        if(i % 10 === 0) {
          setExportProgress(Math.floor((i / selectedList.length) * 100))
        }
        const item = selectedList[i]
        const rowIndex = i + 2

        worksheet.getRow(rowIndex).height = 50

        worksheet.getCell(`B${rowIndex}`).value = item.brand_names || ''
        worksheet.getCell(`C${rowIndex}`).value = item.part_name || ''
        worksheet.getCell(`D${rowIndex}`).value = item.code || ''
        worksheet.getCell(`E${rowIndex}`).value = item.quality_oe || item.oe || ''
        worksheet.getCell(`F${rowIndex}`).value = item.inputnum || 1
        worksheet.getCell(`G${rowIndex}`).value = item.is_unmatched ? '' : (item.quality_price ? `${priceUnit}${item.quality_price}` : intl.formatMessage({ id: '待报价' }))
        worksheet.getCell(`H${rowIndex}`).value = item.is_unmatched ? '' : (item.quality_price ? `${priceUnit}${item.quality_price * (item.inputnum || 1)}` : intl.formatMessage({ id: '待报价' }))

        const imgUrl = item.images || (item.oe_image_info && item.oe_image_info.imagePath) || ''
        if(imgUrl) {
          try {
            const response = await fetch(imgUrl)
            const blob = await response.blob()
            const arrayBuffer = await blob.arrayBuffer()

            const imageId = workbook.addImage({
              buffer: arrayBuffer,
              extension: 'png',
            })

            worksheet.addImage(imageId, {
              tl: { col: 0, row: rowIndex - 1 },
              ext: { width: 50, height: 50 }
            })
          } catch (error) {
            console.error(`插入图片失败:`, error)
          }
        }
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const filename = `OE匹配结果_${new Date().getTime()}.xlsx`
      _window.saveAs(blob, filename)

      setExportLoading(false)
      setExportProgress(0)
      message.success(intl.formatMessage({ id: '导出成功' }))
    } catch (error) {
      setExportLoading(false)
      setExportProgress(0)
      console.error('导出Excel失败:', error)
      message.error(intl.formatMessage({ id: '导出失败' }))
    }
  }

  console.log(list)
  return (
    <div className="mr10">
      <Button type="primary" size="large" style={btnStyle}>
        <label key={fileKey} htmlFor="exportinOe" onChange={(e) => exportinOe(e)}>
          <input accept=".xlsx" type="file" id="exportinOe" style={{ display: 'none' }}  />
          <span className="pointer">+ {intl.formatMessage({ id: 'Excel导入' })}</span>
        </label>
        
        
      </Button>
      <Popover
        title={
          <div className="flex-b-c">
            <span>{intl.formatMessage({ id: '样式参考' })}</span>
            <u className="p-color pointer" onClick={() => downloadFile('https://xqpcdns.007vin.com/1773726117128.列表模版.xlsx')}>{intl.formatMessage({ id: '下载模版' })}</u>
          </div>
        }
        content={
          <div>
            <img src="https://xqpcdns.007vin.com/1773726343348.企业微信截图_076c1be2-cd4c-404f-b761-26bffc993b5c.png" style={{ width: 440 }}/>
          </div>
        }
      >
        <QuestionCircleOutlined className="ml10 pointer p-color" style={{ fontSize: 20, ...qStyle }} />
      </Popover>


      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={1000}
        styles={{
          content: {
            padding: 0
          }
        }}
        centered
        maskClosable={false}
      >
        <Spin spinning={loading}>
        <div className={styles['resultoe']}>
          <div className={styles['header'] + ' flex-s-c plr30'}>
            <FileDoneOutlined className="mr10" />{intl.formatMessage({ id: 'Excel导入匹配结果' })}
          </div>
          <div className={styles['body'] + ' p20'}>
            <h3>{intl.formatMessage({ id: '匹配结果列表' })}</h3>
            <div className={styles['result-tabs'] + " mtb10"}>
              <div onClick={() => setTab("success")} className={styles['item'] + ' ' + styles['success'] + ' ' + `${tab === 'success' ? styles['active'] : ''}` + ' flex-c-c plr10 ptb5 mr10 pointer'}>
                <CheckCircleOutlined />
                <span className="mlr5">{intl.formatMessage({ id: '匹配成功' })}</span>
                <span className={styles['num'] + ' flex-c-c'}>{list.length}</span>
              </div>
              <div onClick={() => {setTab("error"); setErrorOpen(true)}} className={styles['item'] + ' ' + styles['error'] + ' ' + `${tab === 'error' ? styles['active'] : ''}` + ' flex-c-c plr10 ptb5 mr10 pointer'}>
                <WarningOutlined />
                <span className="mlr5">{intl.formatMessage({ id: '匹配失败' })}</span>
                <span className={styles['num'] + ' flex-c-c'}>{errorList.length}</span>
              </div>
            </div>
            <Table
              rowKey={'code'}
              rowSelection={{
                selectedRowKeys: rowKeys,
                onChange(selectedRowKeys, selectedRows, info) {
                  console.log(selectedRowKeys)
                  setRowKeys(selectedRowKeys)
                },
                getCheckboxProps: (record) => ({
                  disabled: !record.quality_price || !record.status || !record.goods_stock_num ? true : false
                })
              }}
              columns={
                columns
              }
              dataSource={list}
              pagination={false}
              scroll={{ y: 600 }}
            />
          </div>
          <div className={styles['footer'] + ' flex-b-c p20'}>
            <div>
              <div className="flex-s-c">
                {intl.formatMessage({ id: '本次选购商品总价' })}：<span style={{ fontSize: 30, fontWeight: 500 }}>{totalMoneny}</span>
              </div>
              {intl.formatMessage({ id: '共计 {n} 件商品'}, {n: totalNum })}
              {
                exportProgress > 0 ? (
                  <Progress percent={exportProgress} className="mt10" style={{ width: 300 }} />
                ): null
              }
            </div>
            <div className="flex-s-c">
              <Button onClick={() => addSelectCart()} loading={cartLoading} className="mr10" type="primary" size="large" style={{ background: '#10B981', borderColor: '#10B981' }} icon={<i className="iconfont icon-caigou" />}>{intl.formatMessage({ id: '加入购物车' })}</Button>
              {
                isXts || true ? <Button onClick={() => generateExcel()} loading={exportLoading} type="primary" size="large" className="mr10" style={{ background: '#52C41A', borderColor: '#52C41A', width: 140 }}>{intl.formatMessage({ id: '一键导出' })}</Button> : null
              }
              <Button onClick={() => toBuy()} loading={submitLoading} type="primary" size="large" style={{ background: '#0070CC', borderColor: '#0070CC', width: 200 }}>{intl.formatMessage({ id: '一键结算' })}</Button>
            </div>
          </div>
        </div>
        </Spin>
      </Modal>

      <Modal
        title={
          <div className="flex-b-c pr30">
            <span>{intl.formatMessage({ id: '匹配失败表单' })}</span>
            <u className="p-color pointer" onClick={() => copytext()}>{intl.formatMessage({ id: '一键复制' })}</u>
          </div>
        }
        open={errorOpen}
        onCancel={() => {setErrorOpen(false); setTab("success")}}
        footer={null}
      >
        {
          errorList.map((it) => {
            return (
              <div className="mtb5">{it}</div>
            )
          })
        }
      </Modal>

      {
        previewImgShow ? <PreviewImg
          src={previewSrc}
          imgList={previewSrcList}
          open={previewImgShow}
          onCancel={closePreviewImg}
        /> : null
      }
    </div>
  )
}

export default ExportinOe